var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M443.92,320.198h-180.746c-3.232,0-5.862-2.63-5.862-5.862V51.062c0-3.232,2.63-5.862,5.862-5.862h180.746c3.232,0,5.862,2.629,5.862,5.862V314.335c0,3.233-2.63,5.862-5.862,5.862ZM263.174,45.45c-3.095,0-5.612,2.518-5.612,5.612V314.335c0,3.095,2.518,5.612,5.612,5.612h180.746c3.095,0,5.612-2.517,5.612-5.612V51.062c0-3.094-2.518-5.612-5.612-5.612h-180.746Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.493,320.198H54.746c-3.232,0-5.862-2.63-5.862-5.862V51.062c0-3.232,2.629-5.862,5.862-5.862H235.493c3.232,0,5.862,2.629,5.862,5.862V314.335c0,3.233-2.63,5.862-5.862,5.862ZM54.746,45.45c-3.094,0-5.612,2.518-5.612,5.612V314.335c0,3.095,2.518,5.612,5.612,5.612H235.493c3.095,0,5.612-2.517,5.612-5.612V51.062c0-3.094-2.518-5.612-5.612-5.612H54.746Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 381.267,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 51.672,
    y: 395.531,
    width: 16.06,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.352,
    y: 392.821,
    width: 53.53,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.732,
    y: 404.821,
    width: 36.25,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.352,
    y: 392.691,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.452,
    y: 392.691,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.212,
    y: 398.921,
    width: 53.89,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 279.874,
    y: 59.718,
    width: 147.209,
    height: 162.895,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.351,
    y: 66.17,
    width: 134.64,
    height: 150.326,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.403 66.17 286.351 208.679 286.351 131.529 303.763 66.17 324.403 66.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.41 66.17 301.279 216.497 293.711 216.497 333.841 66.17 341.41 66.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.991 107.163 420.991 184.327 412.468 216.497 391.828 216.497 420.991 107.163",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.864,
    y: 59.718,
    width: 5.229,
    height: 162.895,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.43,
    y: 92.771,
    width: 141.83,
    height: 5.229,
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.261,
    y: 302.9,
    width: 183.357,
    height: 60.238,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.085,
    y: 295.553,
    width: 11.528,
    height: 87.741,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.292,295.553v87.741h6.146v-13.977H239.081v13.977h6.146v-87.741H56.292Zm6.146,10.753h85.248v52.225H62.438v-52.225Zm91.383,0h85.259v52.225h-85.248l-.011-52.225Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.278,333.02c0,2.044-1.657,3.701-3.701,3.701s-3.701-1.657-3.701-3.701,1.657-3.701,3.701-3.701,3.701,1.657,3.701,3.701Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.313,333.02c0,2.044-1.657,3.701-3.701,3.701s-3.701-1.657-3.701-3.701,1.657-3.701,3.701-3.701,3.701,1.657,3.701,3.701Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.001,333.02c0,2.044-1.657,3.701-3.701,3.701s-3.701-1.657-3.701-3.701,1.657-3.701,3.701-3.701,3.701,1.657,3.701,3.701Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.047,333.02c0,2.044-1.657,3.701-3.701,3.701s-3.701-1.657-3.701-3.701,1.657-3.701,3.701-3.701,3.701,1.657,3.701,3.701Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.151,
    y: 57.949,
    width: 105.784,
    height: 137.438,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.286,
    y: 68.526,
    width: 89.513,
    height: 116.284,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.889,
    y: 75.8,
    width: 78.306,
    height: 101.736,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.495,133.3c-9.767,0-27.644,27.657-27.644,27.657v16.579h71.893s-28.57-44.236-44.249-44.236Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.426,112.569c0,5.941-4.816,10.757-10.757,10.757s-10.757-4.816-10.757-10.757,4.816-10.757,10.757-10.757h0c5.934-.007,10.75,4.798,10.757,10.731v.026Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M407.34,352.614c-.018-.563-1.913-56.493-11.011-65.339-8.848-8.602-19.004-.32-19.43,.036l-.912-1.093c.115-.097,11.576-9.453,21.336,.036,9.506,9.244,11.366,63.989,11.44,66.315l-1.422,.045Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.121,363.606c-.065-.669-6.217-67.144,18.059-95.005l1.073,.934c-23.874,27.4-17.779,93.27-17.716,93.932l-1.417,.139Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.223,356.574l-1.421-.094c.05-.754,4.751-75.573-13.056-91.952l.964-1.049c18.306,16.839,13.718,89.988,13.513,93.095Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.541,356.532l-1.424-.011c.017-2.061,.587-50.537,14.357-58.428,3.061-1.756,6.058-2.048,8.91-.869,8.326,3.444,12.452,18.263,12.624,18.891l-1.374,.376c-.04-.148-4.114-14.776-11.796-17.951-2.421-1-4.996-.736-7.656,.788-13.067,7.488-13.637,56.709-13.641,57.205Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.179,356.567l-1.421-.081c.021-.382,2.077-38.308-8.158-51.671-2.48-3.237-5.172-4.78-8.016-4.582-6.706,.469-12.33,10.283-12.386,10.381l-1.24-.701c.244-.431,6.054-10.578,13.524-11.101,3.342-.238,6.457,1.493,9.248,5.137,10.556,13.781,8.54,51.038,8.448,52.616Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.423,361.726c-.279-3.679-6.691-90.276,4.591-105.535l1.144,.845c-10.97,14.838-4.384,103.686-4.316,104.582l-1.419,.108Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434.453,306s-6.768,2.495-4.756,8.386c2.012,5.891,23.415,15.586,23.415,15.586,0,0,8.964-8.216,.732-21.578-8.232-13.362-19.207-6.61-19.39-2.394Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.029,294.786s7.207-.302,7.617,5.91c.409,6.211-15.614,23.396-15.614,23.396,0,0-11.435-4.134-8.979-19.635,2.456-15.501,15.185-13.493,16.976-9.672Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.927,265.052s4.805-.516,4.418-3.443c-.387-2.927-18.68-10.46-29.473,1.721,0,0,6.911,11.871,16.901,12.026,9.99,.155,8.153-10.305,8.153-10.305Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.881,257.944s-4.351,2.104-5.571-.585c-1.22-2.689,10.321-18.757,25.924-14.127,0,0,.413,13.73-7.983,19.145-8.396,5.416-12.37-4.433-12.37-4.433Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.13,303.632s3.316-2.678-.263-3.985c-3.579-1.307-21.14-.936-21.323,16.46,0,0,20.453,3.399,22.985-3.227,2.532-6.626-1.399-9.248-1.399-9.248Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.838,264.616s-3.316-2.678,.263-3.985c3.579-1.307,21.14-.936,21.323,16.46,0,0-20.453,3.399-22.985-3.227-2.532-6.626,1.399-9.248,1.399-9.248Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.025,278.629s-.292-3.255,2.336-1.979c2.628,1.276,11.783,11.152,2.293,20.525,0,0-12.774-9.461-10.472-14.388,2.303-4.927,5.843-4.158,5.843-4.158Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.165,283.268s1.983-2.598-.921-2.92c-2.903-.322-15.915,3.151-12.885,16.14,0,0,15.852-1.191,16.531-6.587,.679-5.396-2.725-6.633-2.725-6.633Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.867 381.623 390.893 381.623 382.389 342.396 430.564 342.396 422.867 381.623",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.488,
    y: 341.828,
    width: 53.851,
    height: 11.28,
    style: {
      fill: "#e6e6e6"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.312,
    cy: 416.816,
    rx: 196.258,
    ry: 30.221,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech_Bubble--inject-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M247.448,191.977c7.734-13.31,3.214-30.369-10.096-38.103-13.31-7.734-30.37-3.214-38.104,10.096-5.971,10.275-4.612,22.769,2.43,31.498l-1.359,8.26,8.637-1.906c.133,.08,.253,.174,.388,.252,13.31,7.734,30.369,3.214,38.103-10.096Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.728,190.078c-.703-.677-1.054-1.501-1.054-2.473s.345-1.782,1.035-2.434c.69-.651,1.572-.977,2.645-.977s1.955,.326,2.645,.977c.69,.652,1.035,1.463,1.035,2.434s-.351,1.796-1.054,2.473c-.703,.677-1.579,1.016-2.626,1.016s-1.923-.338-2.626-1.016Zm-.939-26.124h7.13l-1.188,17.518h-4.753l-1.188-17.518Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.812,152.349c-.098,0-.197-.029-.284-.089-7.804-5.395-18.755-6.18-27.25-1.952-.246,.124-.547,.022-.67-.225-.123-.247-.022-.547,.225-.67,8.81-4.385,20.168-3.572,28.264,2.025,.228,.157,.284,.468,.127,.695-.097,.141-.253,.216-.412,.216Z",
    style: {
      fill: "#2784B9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dog--inject-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.91,290.813s10.6,8.299,12.025,11.414c1.425,3.115,5.284,19.115,5.284,19.115l2.231,.486,13.538-11.192,1.9,21.331s-8.003,10.995-19.393,9.099c-11.39-1.896-9.807-34.388-9.657-34.004,.15,.383-7.063-.837-7.396-6.284-.333-5.448,1.468-9.964,1.468-9.964Z",
    style: {
      fill: "#2784B9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Dog--inject-2--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.19,363.77l-35.331-6.852,4.029,12.225c-2.636-1.028-5.42-1.628-8.245-1.778-6.218-.51-14.202,0-17.858,5.733l1.244-.846c-1.947,2.08-2.334,5.178-.958,7.673l.187-.908c2.549,8.183,14.985,10.26,24.872,10.608,0,0-13.68,.174-15.682,3.967s3.146,3.395,9.315,3.395h24.872c3.979,0,3.582-2.413,3.582-2.413,0,0,12.747,2.375,14.786-11.603,.535-3.706-1.592-11.031-4.813-19.201Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.084,381.093c12.834,7.735,31.923-19.114,13.431-39.796,0,0,12.722,1.99,15.309,14.724l1.393-5.372s9.153,16.391,0,27.086l5.372-1.43s-12.436,26.974-40.43,14.513l4.925-9.725Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.589,376.317c-.311,.659-12.834,26.8-40.43,14.501l4.974-9.725c1.802,1.085,3.921,1.524,6.007,1.244,1.283,2.596,1.809,5.501,1.517,8.382,0,0,17.995,1.393,27.931-14.401Z",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.888,341.298s9.7,48.327,9.29,49.322c-.41,.995-9.141,1.057-7.661,6.38h14.786s1.791-1.803,0-5.982c-1.244-2.835,0-28.889,0-28.889,1.879-3.3,2.692-7.101,2.326-10.882-.435-3.731-18.741-9.949-18.741-9.949Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.888,341.298s9.7,48.327,9.29,49.322c-.41,.995-9.141,1.057-7.661,6.38h14.786s1.791-1.803,0-5.982c-1.244-2.835,0-28.889,0-28.889,1.879-3.3,2.692-7.101,2.326-10.882-.435-3.731-18.741-9.949-18.741-9.949Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.589,318.042s-1.318,8.158,.87,14.923l2.263-3.383c.635,4.735,2.235,9.289,4.701,13.381l.883-3.01c.187,.323,.373,.634,.572,.945,11.192,17.784,18.182,56.099,18.182,56.099h26.116l30.729-30.332c-5.696-15.321-16.167-35.045-20.308-39.273-17.933-18.53-31.55-13.68-32.918-39.795l-21.141-5.633s-8.705,13.829-9.663,27.981c-1.118,3.459-1.681,7.073-1.666,10.708l1.38-2.612Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.905,366.667l-30.742,30.394h-26.116s-6.964-38.316-18.194-56.099c-.199-.311-.385-.622-.572-.945l-.883,3.01c-2.466-4.092-4.066-8.646-4.701-13.381l-2.263,3.37c-2.176-6.753-.858-14.923-.858-14.923l-1.368,2.562c-.008-3.658,.567-7.293,1.704-10.77,.933-14.152,9.663-27.981,9.663-27.981l9.041,2.4,12.1,3.221c.094,4.41,.909,8.775,2.413,12.921,4.887,12.225,16.341,12.287,30.493,26.912,4.067,4.203,14.587,23.927,20.283,39.31Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M293.944,296.493c-4.855-1.822-9.46-11.004-9.446-14.704,.014-3.7,12.019-28.977,23.524-23.872,0,0-9.223,40.398-14.078,38.576Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.704,300.082c.882-4.159,1.972-5.992,2.665-10.945l10.296-6.43,10.6,3.478s-4.076,10.906-21.646,14.245l1.989-1.989c-2.433,.643-1.556,.736-3.905,1.641Z",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.879,281.831c-.101,1.563,.261,3.122,1.043,4.479v-.876c.942,2.26,2.44,4.246,4.354,5.773l-.668-2.17c1.699,1.368,3.72,2.278,5.87,2.643l-.139-.626,.264,.097c11.073,3.617,22.967,4.201,34.389-3.951,9.028-6.441,3.812-17.765,1.21-22.258l2.295-.89c-.473-4.312-6.747-8.138-14.203-7.206-6.093,.779-9.181-1.822-9.181-1.822-.061,.7,.231,1.383,.779,1.822-2.727-.278-4.605-3.325-4.605-3.325-.599,2.068,.157,4.29,1.892,5.565-1.145,.216-2.24,.646-3.227,1.266-4.452,3.172-5.537,7.122-6.622,8.347-1.085,1.224-8.875,2.101-13.424,3.77-1.586,.598-2.017,5.078,.125,9.64l-.153-.278Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.879,281.831c-.101,1.563,.261,3.122,1.043,4.479v-.876c.942,2.26,2.44,4.246,4.354,5.773l-.668-2.17c1.699,1.368,3.72,2.278,5.87,2.643l-.139-.626,.264,.097c11.073,3.617,22.967,4.201,34.389-3.951,9.028-6.441,3.812-17.765,1.21-22.258l2.295-.89c-.473-4.312-6.747-8.138-14.203-7.206-6.093,.779-9.181-1.822-9.181-1.822-.061,.7,.231,1.383,.779,1.822-2.727-.278-4.605-3.325-4.605-3.325-.599,2.068,.157,4.29,1.892,5.565-1.145,.216-2.24,.646-3.227,1.266-4.452,3.172-5.537,7.122-6.622,8.347-1.085,1.224-8.875,2.101-13.424,3.77-1.586,.598-2.017,5.078,.125,9.64l-.153-.278Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.125,298.9c5.119-.918,11.338-9.112,11.964-12.757s-6.608-30.674-18.85-27.725c0,0,1.767,41.4,6.886,40.482Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.347,267.558c.946,0,1.751,1.313,1.751,2.942s-.823,2.942-1.751,2.942-1.751-1.314-1.751-2.942,.806-2.942,1.751-2.942Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.897,265.252c.892,.207,1.354,1.545,1.035,2.978-.319,1.433-1.274,2.437-2.182,2.246-.908-.191-1.37-1.529-1.051-2.962,.319-1.449,1.306-2.469,2.198-2.262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.117,277.324s-2.226-4.118-.556-4.716c1.943-.32,3.884,.579,4.897,2.268,.556,2.003-4.34,2.448-4.34,2.448Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.671,347.516c.249,3.153,.001,6.325-.734,9.402l-1.356-1.691c-.309,3.125-1.87,5.992-4.328,7.947l-.199,5.982c-3.072,1.896-4.821,5.356-4.527,8.954,.472,4.514,4.8,7.325,4.8,7.325l.41,6.691s1.244,3.209-.41,4.887h18.356l4.887-27.857c-5.128-3.56-11.39-5.101-17.585-4.328,0,0,4.564-8.656,.684-17.311Z",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.774,363.77l-35.331-6.852,4.029,12.225c-2.636-1.028-5.42-1.628-8.245-1.778-6.28-.51-14.202,0-17.858,5.733l1.244-.846c-1.947,2.08-2.334,5.178-.958,7.673l.187-.908c2.487,8.183,14.998,10.26,24.872,10.608,0,0-13.68,.174-15.682,3.967s3.159,3.395,9.315,3.395h24.872c3.979,0,3.582-2.413,3.582-2.413,0,0,12.747,2.375,14.786-11.603,.584-3.706-1.53-11.031-4.813-19.201Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.774,363.77l-35.331-6.852,4.029,12.225c-2.636-1.028-5.42-1.628-8.245-1.778-6.28-.51-14.202,0-17.858,5.733l1.244-.846c-1.947,2.08-2.334,5.178-.958,7.673l.187-.908c2.487,8.183,14.998,10.26,24.872,10.608,0,0-13.68,.174-15.682,3.967s3.159,3.395,9.315,3.395h24.872c3.979,0,3.582-2.413,3.582-2.413,0,0,12.747,2.375,14.786-11.603,.584-3.706-1.53-11.031-4.813-19.201Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.603,300.756c9.841,5.153,21.724,4.439,30.879-1.853,.067-.069,.178-.07,.246-.003l.003,.003,1.244,2.736c.062,.125,.037,.275-.062,.373-1.617,1.642-15.197,14.476-33.304,3.072-.294-.183-.439-.533-.361-.87l.783-3.283c.08-.197,.306-.292,.503-.211,.024,.01,.048,.022,.069,.037Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.465,
    y: 307.481,
    width: 6.765,
    height: 6.765,
    rx: 1.865,
    ry: 1.865,
    transform: "translate(-129.062 310.145) rotate(-45)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.636,285.676c-1.632,0-3.332-.363-5.001-1.075-.785-.334-1.906-.894-2.57-1.879-.733-1.088-.77-2.407-.805-3.683-.021-.744-.042-1.514-.203-2.22-.03-.135,.054-.269,.188-.3,.135-.025,.27,.054,.3,.188,.172,.755,.193,1.549,.215,2.317,.034,1.26,.066,2.449,.719,3.417,.456,.676,1.181,1.199,2.352,1.698,2.199,.938,4.445,1.243,6.502,.893,2.29-.395,4.276-1.627,5.451-3.38,.078-.115,.235-.145,.347-.069,.115,.077,.146,.232,.069,.347-1.251,1.867-3.358,3.177-5.783,3.595-.58,.101-1.176,.15-1.78,.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.961,282.3c-.016,0-.031,0-.046-.003-.407-.048-.704-.4-.816-.97-.007-.022-.011-.047-.011-.071,0-.129,.098-.238,.227-.251,.134-.013,.249,.093,.273,.219,.031,.164,.133,.547,.385,.577,.111-.01,.51-.274,.51-.471,0-.138,.112-.25,.25-.25s.25,.112,.25,.25c0,.279-.186,.504-.342,.644-.188,.167-.463,.326-.68,.326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.846,263.94c-.088,0-.177-.031-.248-.094-1.275-1.124-3.101-1.608-4.766-1.262-.208,.04-.401-.09-.443-.291-.042-.203,.088-.401,.291-.443,1.891-.393,3.966,.157,5.414,1.434,.155,.137,.17,.374,.033,.529-.074,.084-.178,.127-.281,.127Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.812,261.922c-.088,0-.177-.031-.248-.094-1.275-1.124-3.098-1.607-4.767-1.261-.197,.039-.4-.087-.443-.291-.042-.202,.088-.401,.291-.443,1.887-.392,3.965,.154,5.415,1.433,.155,.137,.17,.374,.033,.529-.074,.084-.178,.127-.281,.127Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.682,358.151c-.248,0-.464-.186-.495-.438-.943-7.611-5.987-14.738-12.851-18.158-.247-.123-.348-.423-.225-.67,.122-.248,.425-.349,.67-.225,7.156,3.564,12.415,10.995,13.397,18.93,.034,.274-.16,.523-.435,.558-.021,.003-.042,.004-.062,.004Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.86,348.88c-.193,0-.377-.112-.459-.301-1.447-3.336-3.666-6.352-6.415-8.72-.209-.181-.232-.496-.053-.705,.181-.209,.496-.231,.705-.053,2.863,2.467,5.173,5.606,6.681,9.079,.109,.254-.007,.548-.26,.658-.065,.027-.133,.041-.199,.041Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M249.041,298.451l7.055-20.37s2.759-1.732,2.739,6.653c-.013,5.342,1.667,21.522-2.748,24.781-4.556,3.364-14.878,8.494-14.878,8.494,0,0-7.94-11.299-6.81-11.808,1.13-.509,13.423-4.535,13.423-4.535",
    style: {
      fill: "#fdbbb5"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M254.127,297.934c.036-.196,2.268-9.525,2.201-9.501-.067,.024,1.624-2.261,2.829,1.56,1.205,3.82-.545,5.951,.312,7.791,.857,1.84,2.579,6.029-2.11,10.355",
    style: {
      fill: "#fdbbb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.36,308.39c-.067,0-.135-.027-.184-.08-.094-.102-.088-.26,.014-.354,4.228-3.9,3.196-7.613,2.053-10.066-.412-.886-.271-1.813-.107-2.888,.194-1.275,.437-2.864-.216-4.934-.505-1.6-1.051-1.99-1.42-2.037-.489-.047-.904,.437-.952,.513l-.005-.003c-.064,.526-.442,2.124-1.697,7.428-.266,1.125-.459,1.94-.473,2.012-.026,.135-.162,.229-.293,.198-.135-.025-.224-.154-.199-.289,.012-.061,.163-.704,.479-2.036,.582-2.459,1.657-7.006,1.719-7.416,0-.043,.008-.087,.027-.125,.091-.183,.679-.861,1.403-.782,.772,.061,1.407,.864,1.888,2.388,.688,2.181,.437,3.832,.233,5.16-.157,1.034-.282,1.853,.066,2.601,.697,1.495,2.817,6.046-2.166,10.645-.049,.045-.109,.066-.17,.066Z",
    style: {
      fill: "#de7e73"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M183.928,262.638c2.053,1.359,29.429,44.045,29.429,44.045l33.924-5.526,7.683,14.291s-19.987,15.395-38.069,20.492-30.811-26.41-31.102-24.832c-.291,1.578-1.865-48.469-1.865-48.469Z",
    style: {
      fill: "#2784B9"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "276.279 439.731 280.959 425.722 247.1 406.833 239.741 428.091 276.279 439.731",
    style: {
      fill: "#fdbbb5"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M276.783,420.831l-2.485,4.623c-.562,1.046-.553,2.298-.041,3.37,2.208,4.623-.245,5.887-5.226,6.947-1.206,1.728,.643,3.361,1.131,3.817l10.714,10.213c.888,.864,2.309,.845,3.174-.044,.154-.158,.283-.338,.385-.534,3.017-5.614,4.445-8.27,8.2-15.258l11.485-21.37c3.131-5.825-2.091-10.188-3.924-8.08-8.184,9.509-15.466,15.443-20.398,17.092-.882,.323-.952-.533-3.015-.776Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.75,412.72c-.088-.675-.492-1.267-1.087-1.596-.3-.214-.695-.237-1.018-.061-1.805,.897-2.21,8.129-2.242,8.949-.013,.086,.013,.173,.071,.238,.108,.119,.292,.129,.411,.022,1.099-1.24,2.067-2.591,2.886-4.031,.693-1.039,1.035-2.273,.978-3.52Zm-1.862-1.059c.136-.079,.307-.064,.428,.036,.419,.257,.708,.681,.793,1.165,.275,1.84-1.851,4.783-3.084,6.318,.233-2.967,.874-7.019,1.862-7.519Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.051,420.108c.208-2.125-.689-7.295-2.304-7.91-.333-.14-.832-.117-1.359,.611-2.066,2.975,2.894,7.391,3.136,7.521,.081,.084,.203,.111,.312,.07,.049-.05,.083-.113,.097-.181l.118-.112Zm-3.252-6.941c.377-.556,.588-.443,.663-.402,1.01,.329,1.96,4.243,1.942,6.665-1.117-1.106-3.813-4.053-2.734-6.06l.129-.203Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.494,425.074c-.087,0-.172-.046-.218-.127-.938-1.656-1.102-3.711-.435-5.496,.049-.13,.191-.195,.322-.146,.129,.049,.194,.192,.146,.322-.616,1.647-.466,3.544,.401,5.074,.067,.12,.025,.272-.095,.341-.039,.021-.081,.032-.123,.032Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.201,423.363c-.087,0-.172-.046-.218-.127-.939-1.658-1.102-3.712-.435-5.496,.049-.13,.191-.196,.322-.146,.129,.049,.194,.192,.146,.322-.616,1.646-.467,3.543,.401,5.074,.067,.12,.025,.272-.095,.341-.039,.021-.081,.032-.123,.032Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.941,420.766c-.087,0-.172-.046-.218-.127-.939-1.656-1.103-3.71-.436-5.496,.049-.13,.19-.196,.322-.146,.129,.049,.194,.192,.146,.322-.616,1.648-.466,3.545,.402,5.074,.067,.12,.025,.272-.095,.341-.039,.021-.081,.032-.123,.032Z",
    style: {
      fill: "#2784B9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "264.995 416.816 269.148 419.132 262.7 435.405 257.841 433.857 264.995 416.816",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.893,345.738l16.893,10.326c21.69,1.073,94.988,1.679,95.203,27.754,7.195,30.735-59.18,27.808-103.304,28.238-.299,.003-.556,.185-.733,.461-.39,.612-4.671,2.806-10.139,3.675-6.736,1.07-22.145,2.006-32.044,.44-17.075-2.7-21.999-18.919-18.732-41.732,1.343-9.375,6.522-16.987,8.096-28.668l44.759-.494Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.603,380.43l.106,1.064s55.82-9.242,89.827,13.109c0,0,36.851-9.042,44.343-15.92-40.817,21.475-77.372-3.39-77.372-3.39l-18.006-8.046c-14.712-6.574-29.527-1.553-38.897,13.183Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.803 416.583 194.249 429.873 231.666 419.713 222.069 399.367 187.803 416.583",
    style: {
      fill: "#fdbbb5"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M202.506,429.59l-3.088-4.244c-.699-.96-1.831-1.495-3.019-1.499-5.123-.015-5.198-2.773-3.993-7.722-1.034-1.835-3.308-.878-3.93-.636l-13.848,5.226c-1.164,.426-1.763,1.715-1.337,2.879,.076,.207,.182,.402,.314,.578,3.75,5.153,5.525,7.592,10.193,14.005l14.276,19.616c3.892,5.347,10.087,2.534,8.983-.032-5.02-11.498-7.209-20.633-6.556-25.791,.091-.935,.893-.627,2.007-2.381Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.926,441.187c.646,.213,1.355,.106,1.91-.288,.322-.177,.515-.523,.496-.891-.026-2.015-6.367-5.517-7.091-5.9-.072-.049-.162-.063-.246-.039-.154,.045-.243,.207-.198,.361,.64,1.529,1.438,2.986,2.381,4.349,.636,1.075,1.599,1.918,2.748,2.408Zm1.762-1.219c.012,.157-.075,.304-.218,.37-.413,.267-.921,.343-1.394,.21-1.777-.55-3.507-3.741-4.355-5.518,2.573,1.497,5.945,3.831,5.968,4.939Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.873,434.651c1.824,1.109,6.872,2.542,8.126,1.354,.271-.239,.466-.699,.039-1.49-1.785-3.151-7.915-.597-8.136-.436-.11,.036-.188,.135-.199,.251,.023,.066,.065,.124,.121,.166l.049,.155Zm7.665,.079c.338,.581,.144,.722,.074,.772-.734,.767-4.673-.074-6.848-1.14,1.481-.527,5.305-1.678,6.646,.164l.127,.204Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.375,435.17c-.065,0-.131-.025-.18-.077-1.218-1.269-2.984-1.945-4.748-1.839-.142,.019-.257-.096-.266-.232-.009-.138,.095-.257,.233-.266,1.9-.132,3.822,.616,5.141,1.991,.096,.1,.093,.258-.007,.354-.049,.046-.111,.069-.173,.069Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.309,439.252c-.066,0-.131-.025-.181-.077-1.217-1.269-2.995-1.948-4.747-1.839-.138,.023-.257-.095-.266-.232-.009-.138,.095-.257,.233-.266,1.898-.13,3.823,.616,5.141,1.991,.095,.1,.092,.258-.008,.354-.048,.046-.111,.069-.173,.069Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.028,443.748c-.066,0-.131-.025-.181-.077-1.217-1.269-2.995-1.943-4.747-1.839-.138,.023-.257-.095-.266-.232-.009-.138,.095-.257,.233-.266,1.898-.132,3.823,.616,5.141,1.991,.095,.1,.092,.258-.008,.354-.048,.046-.111,.069-.173,.069Z",
    style: {
      fill: "#2784B9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M266.174,415.617s-85.93-48.104-115.443-49.018c-29.513-.914-32.858,21.359-22.001,38.502,10.857,17.143,38.096,8.833,38.096,8.833,0,0-21.548-5.453-18.88-11.296,2.668-5.843,10.627,3.225,10.627,3.225,0,0,52.207,21.437,98.793,29.035l8.808-19.281Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.897 391.804 249.556 407.768 252.476 407.458 226.297 390.966 221.897 391.804",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.004,413.209s-27.872-11.058-27.563-11.058,17.565,12.934,23.215,12.873l4.348-1.815Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.844,279.701c5.315,15.963,5.565,52.038,3.682,71.966l60.269-.383c10.364-39.757,6.865-67.651,5.982-76.965-1.1-11.331-2.849-11.764-2.849-11.764,0,0-12.297-1.2-22.994-1.116-8.284,.31-16.536,1.207-24.694,2.683-6.069,1.014-12.077,2.365-17.996,4.049-2.54,.723-4.014,3.368-3.291,5.908,.023,.081,.048,.161,.075,.24,.633,1.783,1.25,3.616,1.816,5.382Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.796,351.284l-36.341,.233-23.928,.15c1.57-18.565,1.408-37.235-.483-55.77-.543-5.489-1.614-10.913-3.199-16.196-.567-1.766-1.183-3.599-1.816-5.466-.855-2.499,.477-5.218,2.975-6.073,.079-.027,.16-.052,.24-.075,5.92-1.656,11.928-2.98,17.996-3.966,8.16-1.448,16.412-2.317,24.694-2.6,10.697-.083,22.994,1.117,22.994,1.117,0,0,1.75,.433,2.849,11.764,.883,9.231,4.382,37.124-5.982,76.882Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.527,351.667c1.57-18.565,1.408-37.235-.483-55.77,7.415,10.531,20.462,31.776,24.411,55.62l-23.928,.15Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.924,266.237c-3.066,4.382,34.625,11.431,34.625,11.431,0,0,22.061-14.313-3.699-16.546-5.249-.466-26.077-1.766-30.926,5.115Z",
    style: {
      fill: "#de7e73"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.782,285.783s20.312-16.763,9.798-26.794c-10.514-10.031-59.986-14.513-55.803,8.331,0,0,6.365-1.883,12.797,4.249,13.547,12.963,33.209,14.213,33.209,14.213Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.083,280.967s11.497-8.931,7.448-16.979c-4.049-8.048-27.977-16.863-45.123-5.765,4.111,2.107,7.931,4.74,11.364,7.832,6.798,5.815,26.31,14.913,26.31,14.913Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.717,282.1c.009,.635-.498,1.157-1.133,1.166-.635,.009-1.157-.498-1.166-1.133-.009-.635,.498-1.157,1.133-1.166,.011,0,.022,0,.033,0,.622,.009,1.124,.511,1.133,1.133Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.181,278.801c.009,.626-.491,1.14-1.116,1.15h-.017c-.63,.076-1.203-.373-1.28-1.003-.076-.63,.373-1.203,1.003-1.28,.092-.011,.185-.011,.276,0,.626,0,1.133,.507,1.133,1.133Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.862,290.298c.009,.635-.498,1.157-1.133,1.166-.635,.009-1.157-.498-1.166-1.133-.009-.635,.498-1.157,1.133-1.166h.017c.629,0,1.141,.504,1.15,1.133Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.118,296.164c0,.626-.507,1.133-1.133,1.133s-1.133-.507-1.133-1.133,.507-1.133,1.133-1.133h0c.626,0,1.133,.507,1.133,1.133Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.446,290.781h0s-4.449-.6-5.215-6.282c-.09-2.748-2.349-4.926-5.099-4.915-.233,0-.433-.167-.433-.4-.018-.22,.145-.414,.365-.432,.011,0,.023-.001,.035-.001,3.165,.003,5.78,2.472,5.965,5.632,.667,4.999,4.449,5.565,4.482,5.582,.224,.026,.386,.225,.367,.45-.034,.226-.239,.387-.466,.367Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.985,296.164c-.224,0-.408-.176-.417-.4-.091-2.924,.982-5.764,2.983-7.898,.784-.689,1.249-1.672,1.283-2.716-.086-1.047-.533-2.03-1.266-2.783-.188-.133-.232-.393-.098-.581,.133-.187,.393-.232,.581-.098,.032,.022,.06,.049,.084,.079,.903,.885,1.448,2.071,1.533,3.333-.026,1.272-.575,2.477-1.516,3.333-1.824,1.967-2.81,4.567-2.749,7.248,.01,.227-.157,.424-.383,.45l-.033,.033Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.585,311.476s-10.312,8.591-16.733,10.292c0,0,11.695,2.036,16.733-10.292Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.301,269.19c-1.038,.372-7.785,6.011-7.461,19.223,.476,19.367,5.246,59.492,7.461,63.255,2.214,3.763,60.832,20.196,61.703,21.148,.87,.952,3.91-10.228,3.91-10.228l-45.131-28.627s-2.669-40.336-3.733-46.386c-1.064-6.05-4.14-22.906-16.749-18.385Z",
    style: {
      fill: "#2784B9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.399,364.407l2.529,1.137s11.946-.943,14.975,2.076c3.029,3.02,4.728,16.797,4.728,16.797l-25.627-11.602,3.396-8.408Z",
    style: {
      fill: "#fdbbb5"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M167.632,208.168c-.097-.004-.191-.039-.267-.1-.159-.162-.159-.421,0-.583,3.22-4.094,2.869-9.95-.816-13.63-6.332-6.748-15.78-1.016-15.88-.966-.174,.15-.437,.13-.587-.044-.15-.175-.13-.437,.045-.587,.033-.028,.07-.051,.109-.068,.1,0,10.131-6.149,16.929,1.1,3.904,4.01,4.267,10.28,.85,14.713-.094,.113-.236,.175-.383,.167Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.949,208.668c-.139-.001-.27-.069-.35-.183-.12-.189-.068-.44,.117-.567,0,0,4.349-2.966,4.832-6.915,.183-2.045-.563-4.064-2.033-5.499-.166-.16-.17-.423-.011-.589l.011-.011c.167-.161,.432-.161,.6,0,1.636,1.614,2.462,3.877,2.249,6.165-.533,4.332-4.999,7.365-5.199,7.498-.06,.056-.136,.09-.217,.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.213,249.141c-3.148,.268-6.237-.968-8.331-3.333-.159-.162-.159-.421,0-.583,.151-.161,.404-.169,.565-.018l.018,.018c4.682,6.099,17.946,.916,18.079,.866,.212-.089,.456,.011,.545,.223l.004,.011c.086,.203-.008,.438-.211,.525l-.022,.009c-3.397,1.35-6.996,2.121-10.647,2.283Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.039,211.067c.95-8.287-4.408-15.988-12.508-17.979-14.5-4.38-29.459,10.025-29.459,10.025,0,0-11.258,46.426,19.908,43.927,31.166-2.498,22.058-35.974,22.058-35.974Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.611,264.682s5.87,3.135,13.531,7.794c1.596,.971,3.306,1.755,5.077,2.349,4.779,1.602,9.003,2.27,9.735-.028,.163-.505,.265-1.04,.314-1.592,.331-3.698-.876-8.618-4.121-10.422-3.658-2.034-5.582-3.975-5.579-7.553-.023-2.024,.352-4.18,.858-6.298l-4.103-1.619-15.529-11.207c2.89,7.975,6.012,22.545-.182,28.574Z",
    style: {
      fill: "#fdbbb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.587,256.014c-4.018-1.562-8.657-4.66-8.892-9.042-.087-1.847,.018-3.628,.269-4.801l9.064,8.598c-.346,1.687-.394,2.771-.441,5.245Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.7,221.408c3.525,13.453,4.73,19.207,12.972,25.197,12.397,9.011,28.108,2.671,28.663-11.338,.5-12.609-5.348-32.491-19.715-36.001-14.155-3.458-25.445,8.688-21.92,22.141Z",
    style: {
      fill: "#fdbbb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.858,222.97c.308,1.434,1.288,2.491,2.19,2.36,.902-.131,1.383-1.4,1.075-2.834-.307-1.434-1.288-2.491-2.189-2.36-.901,.131-1.383,1.399-1.075,2.834Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.723,220.442c.301,1.389,1.274,2.41,2.172,2.28,.899-.131,1.384-1.363,1.083-2.752-.301-1.389-1.274-2.41-2.173-2.279-.899,.13-1.383,1.362-1.082,2.752Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.3,214.919c.177-.01,.345-.09,.46-.237,1.78-2.299,4.264-2.009,4.293-2.006,.368,.044,.69-.214,.711-.586,.02-.371-.266-.71-.639-.759-.13-.016-3.248-.383-5.457,2.471-.22,.284-.154,.712,.147,.955,.146,.116,.319,.169,.485,.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.992,209.207c.13-.069,.227-.19,.263-.35,.073-.33-.145-.698-.485-.821-3.415-1.236-5.507,.484-5.595,.559-.247,.209-.249,.608-.003,.891,.245,.283,.644,.343,.892,.136,.081-.069,1.726-1.375,4.441-.392,.176,.063,.35,.05,.487-.024Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.826,220.572s2.988,4.758,5.93,7.545c.514,.487,.389,1.344-.227,1.694-1.584,.901-3.651,.668-3.651,.668l-2.052-9.907Z",
    style: {
      fill: "#de7e73"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.428,220.134l3.012-1.262s-1.326,2.624-3.012,1.262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.342,217.819l3.012-1.263s-1.326,2.624-3.012,1.263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.219,221.815s3.679-10.414-2.214-16.739c0,0,23.945-11.311,31.578,12.603,0,0-1.26-23.487-24.8-21.829-23.54,1.658-19.663,39.793-6.573,48.874,.016,.032-1.213-15.502,2.008-22.909Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.42,233.23c2.08,2.533,4.995,3.856,7.499,4.059,3.767,.305,4.667-5.82,2.83-9.237-1.654-3.077-5.567-4.644-8.968-3.347-3.35,1.278-3.74,5.629-1.361,8.525Z",
    style: {
      fill: "#fdbbb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.94,231.48c-.114,0-.216-.078-.243-.193-.288-1.222-1.065-2.303-2.132-2.965s-2.381-.879-3.604-.594c-.136,.032-.269-.053-.3-.187s.053-.269,.187-.3c1.35-.313,2.801-.076,3.981,.657,1.179,.731,2.037,1.925,2.355,3.275,.032,.134-.051,.269-.186,.3-.019,.005-.039,.007-.057,.007Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.549,234.712c-.624,1.572-1.137,3.187-1.533,4.832h-.9c-4.049-.35-5.799-1.85-6.532-3.333-.34-.764-.489-1.599-.433-2.433,.014-.475,.093-.946,.233-1.4,2.401,1.328,5.061,2.118,7.798,2.316,.833-.017,1.366,.017,1.366,.017Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.183,234.562l-.5,1.416c-3.799-.333-6.448-1.083-7.532-2.333,.014-.475,.093-.946,.233-1.4,2.401,1.328,5.061,2.118,7.798,2.316Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.117,239.477c-4.049-.35-5.799-1.85-6.532-3.332,1.537,.159,3.032,.594,4.416,1.283,.9,.448,1.639,1.164,2.116,2.05Z",
    style: {
      fill: "#d7504d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.241,203.604s6.798-10.814-4.749-15.113c-11.547-4.299-22.728,10.581-15.813,20.862,3.865,5.934,11.192,8.592,17.962,6.515l2.599-12.264Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.991,202.555c-.096,.009-.192-.021-.267-.083-.161-.151-.169-.404-.018-.565l.018-.018c.3-.35,6.998-8.648,.816-13.83-.159-.162-.159-.421,0-.583,.151-.161,.404-.169,.565-.018l.018,.018c6.832,5.699-.633,14.896-.7,14.997-.117,.108-.285,.14-.433,.083Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.611,218.617c-6.851-.273-12.183-6.047-11.91-12.897,.027-.678,.109-1.352,.246-2.016,.716-3.649,2.966-6.032,6.032-6.365,.218-.037,.424,.109,.462,.327,.002,.013,.004,.027,.005,.04,.02,.224-.143,.424-.366,.45-2.699,.3-4.682,2.433-5.315,5.715-.972,4.848,1.218,9.783,5.465,12.314,7.582,4.066,10.364-.816,10.464-1.016,.11-.202,.362-.277,.565-.168h.002c.196,.102,.274,.343,.173,.54l-.006,.011c-1.265,1.973-3.473,3.138-5.815,3.066Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.966,
    cy: 228.345,
    rx: 4.949,
    ry: 1.95,
    style: {
      fill: "#de7e73",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.909,229.443c-2.733,0-4.949-.873-4.949-1.95s2.216-1.95,4.949-1.95h.71l.531,3.9h-1.242Z",
    style: {
      fill: "#de7e73",
      opacity: 0.4
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighFive);
export default __webpack_public_path__ + "static/media/highFive.ff161236aef311cd1f5ae8ae9b9bbd64.svg";
export { ForwardRef as ReactComponent };